import { Component, Input } from '@angular/core';

import { tv } from 'tailwind-variants';

import { FeedbackOptions } from '../../utils/feedback';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
  standalone: false,
})
export class MessageBoxComponent {
  @Input() class = '';

  @Input() title = 'Info';
  @Input() message = '';

  @Input() type: 'info' | 'warning' | 'error' | 'success' = 'info';

  @Input() feedback: FeedbackOptions | null = null;

  private variants = tv({
    slots: {
      base: 'mb-8 rounded-3xl p-4',
      icon: 'h-5 w-5',
      title: 'text-sm font-medium',
      message: 'mt-2 text-sm',
    },
    variants: {
      type: {
        info: {
          base: 'bg-blue-50',
          icon: 'text-blue-500',
          title: 'text-blue-700',
          message: 'text-blue-700',
        },
        warning: {
          base: 'bg-orange-100',
          icon: 'text-orange-500',
          title: 'text-orange-700',
          message: 'text-orange-700',
        },
        error: {
          base: 'bg-red-100',
          icon: 'text-red-400',
          title: 'text-red-600',
          message: 'text-red-600',
        },
        success: {
          base: 'bg-green-100',
          icon: 'text-green-500',
          title: 'text-green-700',
          message: 'text-green-700',
        },
      },
    },
    compoundVariants: [],
    defaultVariants: {},
  });

  get options(): FeedbackOptions {
    return (
      this.feedback ?? {
        visible: false,
        type: this.type,
        title: this.title,
        message: this.message,
      }
    );
  }

  get baseClasses(): string {
    return this.variants({
      type: this.options.type,
    }).base({
      // overrides
      class: this.class,
    });
  }

  get iconClasses(): string {
    return this.variants({
      type: this.options.type,
    }).icon();
  }

  get titleClasses(): string {
    return this.variants({
      type: this.options.type,
    }).title();
  }

  get messageClasses(): string {
    return this.variants({
      type: this.options.type,
    }).message();
  }
}
